// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"197":"component---src-templates-example-js","332":"component---src-templates-index-js","351":"commons","883":"component---src-pages-404-js"}[chunkId] + "-" + {"197":"0124938ac3603e31f569","332":"bdc45b6c532da12ae3b4","351":"131864d57582619aebb9","883":"da5f92d779f8291e83fb"}[chunkId] + ".js";
};